import { DateTime } from 'luxon';
import { Admin } from '../../admin/admin';
import { User } from '../../user/user';
import { PaginationRequest } from '../../pagination/pagination';

export enum OnAccountStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Declined = 'Declined',
}

export class OnAccount {
  userId!: number;
  accountNumber!: string;
  status!: OnAccountStatus;
  readonly requestedAt?: DateTime;
  readonly updatedAt?: DateTime;
  readonly approvedAt?: DateTime;
  readonly approvedBy?: Admin;
}

export type AccountRequest = OnAccount & {
  readonly user: Pick<User, 'name' | 'email'>;
};

export class AccountSearchRequest extends PaginationRequest {
  keyword?: string;
  statusFilter?: OnAccountStatus;
  requestedAfter?: DateTime;
  requestedBefore?: DateTime;
}
